var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
          _vm._v("油品销量分布")
        ]),
        _c("el-date-picker", {
          staticStyle: { width: "20rem !important" },
          attrs: {
            editable: false,
            type: "daterange",
            "range-separator": "~",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "timestamp",
            "picker-options": _vm.pickerOptionsLimit
          },
          model: {
            value: _vm.datePickerValue,
            callback: function($$v) {
              _vm.datePickerValue = $$v
            },
            expression: "datePickerValue"
          }
        }),
        _c(
          "el-tabs",
          { staticClass: "chart-wrapper", attrs: { "tab-position": "top" } },
          [
            _c(
              "el-tab-pane",
              { attrs: { lazy: true, label: "时段分布情况" } },
              [
                _c("slot-counter-station-sold-distribution-sheet", {
                  attrs: {
                    start: _vm.datePickerValue[0],
                    end: _vm.datePickerValue[1],
                    "total-id":
                      parseInt(_vm.userInfo.authorityId) < 30003
                        ? 999
                        : _vm.userInfo.sellerId,
                    "total-counter-name":
                      "StationOilSoldTimeDistributionSlotCounter",
                    "total-counter-display-name":
                      "StationOilSoldTimeDistributionSlotCounter",
                    "total-counter-kind": "CST",
                    "sheet-type": "daySold",
                    "slot-counter-name": "StationSoldDistributionCounter"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }